module.exports = __webpack_public_path__ + "img/icon-chair.0526af56.png";